var map = {
	"./Arla_AamuPlus_Holding_Device.png": 7692,
	"./Group27.svg": 7458,
	"./Group47@2x.png": 6164,
	"./aamu-plus-wordmark.svg": 6471,
	"./arla-bubble.svg": 6101,
	"./arla-lintu.png": 6343,
	"./arla-logo.png": 2682,
	"./arla-luontoplus-bg.png": 5175,
	"./background_mobile.png": 5931,
	"./background_mobile@2x.png": 37,
	"./background_mobile@3x.png": 4586,
	"./background_raspberry2.png": 9845,
	"./background_raspberry2@2x.png": 2991,
	"./background_raspberry2@3x.png": 7236,
	"./bird_template-01.png": 7634,
	"./bird_template-02.png": 3721,
	"./bird_template-03.png": 7472,
	"./bird_template-04.png": 9695,
	"./bubble_blue_3.png": 3961,
	"./bubble_red_2.png": 2393,
	"./bubble_yellow_1.png": 4287,
	"./close.svg": 8298,
	"./dab.gif": 7652,
	"./dance.gif": 2340,
	"./fly.gif": 2714,
	"./heart.png": 3130,
	"./heart@2x.png": 6602,
	"./heart@3x.png": 3557,
	"./icon-facebook.svg": 6470,
	"./icon-instagram.svg": 2594,
	"./icon-whatsapp.svg": 3556,
	"./jump.gif": 6019,
	"./kamut.png": 9900,
	"./kamutbg.jpg": 6889,
	"./mll-logo.png": 9427,
	"./mll-logo@2x.png": 5021,
	"./mll-logo@3x.png": 9634,
	"./mll_ver.png": 9397,
	"./mll_ver@2x.png": 5567,
	"./mll_ver@3x.png": 6900,
	"./video_background-01.png": 7182,
	"./video_background-02.png": 3909,
	"./video_background-03.png": 2284,
	"./video_background-04.png": 5331,
	"./walk.gif": 1592
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1382;